.button {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: var(--spacing-xxs);
    max-height: 26px;
    padding-inline: var(--spacing-xs);
    padding-block: var(--spacing-xxs);
    border: 1px solid transparent;
    background-color: transparent;
    color: var(--colorTextSecondary);
    font-family: var(--fontFamilySansMedium), sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.25;
    cursor: pointer;
    outline: none;
    border-radius: 1000px;
}

.button[data-hovered] .label,
.button[data-pressed] .label {
    text-decoration: underline;
}

.button[data-focus-visible] {
    border-color: var(--colorBorderAccent);
}

.button[data-disabled] {
    color: var(--colorTextDisabled);
    cursor: default;
}

.filled {
    color: var(--colorTextPrimary);
}

.emphasized {
    color: var(--colorTextAccent);
}

.iconOnly {
    width: 32px;
    height: 24px;
    padding: 0;
    justify-content: center;
}
